import  './benefit-section.styles.css';
import { FaShippingFast } from "react-icons/fa";
import { IoReturnUpBack } from "react-icons/io5";
import { FiShield } from "react-icons/fi";
import { CgTrack } from "react-icons/cg";
import BenefitBox from '../benefit-box/benefit-box.component';

const BenefitSection = () => {

    const BenefitData = [
        {
            id:1,
            text:"ارسال سریع ",
            icon:<FaShippingFast />,
        },
        {
            id:2,
            text:"بازگشت محصول ",
            icon:<IoReturnUpBack />,
        },
        {
            id:3,
            text:"خرید مطمئن",
            icon:<FiShield />,
        },
        {
            id:4,
            text:"پیگیری سفارش",
            icon:<CgTrack />,
        },
    ]

  return (
    <div className="benefit-section">

        {
            BenefitData.map((benefit)=>(
                <BenefitBox key={benefit.id} cat={benefit} />
            ))
        }

    </div>
  )
}

export default BenefitSection